import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "rename"
})
export class RenamePipe implements PipeTransform {
  transform(value: string, args?: any): string {
    switch (value) {
      case "CONF_CHAT_MESSAGE":
        return "NEW MESSAGE";
      case "TRANSLATED_MAIN_INFO_DONE":
        return "TRANSLATION INFORMATION COMPLETED";
    }
    return value.replace(/\_/gi, " ");
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/pipes/rename.pipe.ts